import { grey } from "@mui/material/colors";

const styles = {
  root: {
    overflow: "auto",
    height: "100vh",
  },
  header: {
    py: 1.5,
    px: 2,
    borderBottom: `1px solid ${grey[300]}`,
  },
  close: {
    fontSize: 14,
    width: 30,
    height: 30,
  },
  title: {
    mt: 2,
    textTransform: "uppercase",
    fontWeight: 700,
    fontSize: 12,
  },
  metricsWrapper: {
    px: 3,
    py: 1,
  },
  infoIcon: {
    ml: 0.5,
    color: grey[700],
  },
};

export default styles;
